import { Dialog } from './Dialog';
import { Button } from './Button';
import { useAlertsStore } from '../../stores/alerts-store';

export function AppAlertDialog() {
  const open = useAlertsStore((s) => s.open);
  const type = useAlertsStore((s) => s.type);
  const title = useAlertsStore((s) => s.title);
  const message = useAlertsStore((s) => s.message);
  const confirmText = useAlertsStore((s) => s.confirmText);
  const cancelText = useAlertsStore((s) => s.cancelText);
  const resolve = useAlertsStore((s) => s.resolve);

  return (
    <Dialog open={open} onClose={() => resolve(false)} title={title}>
      <div className="space-y-5">
        <p className="text-sm text-text">{message}</p>
        <div className="flex justify-end gap-2">
          {type === 'confirm' && (
            <Button variant="secondary" onClick={() => resolve(false)}>
              {cancelText}
            </Button>
          )}
          <Button onClick={() => resolve(true)}>{confirmText}</Button>
        </div>
      </div>
    </Dialog>
  );
}
